import React, { useEffect } from "react";

import classes from "./BookingCurrencyConverter.module.css";

import { useDispatch, useSelector } from "react-redux";

import { quoteActions } from "../../store/quote-slice";

const apiCurrnecyKey = process.env.REACT_APP_API_CURRENCY;

const BookingCurrencyConverter = (props) => {
  const dispatch = useDispatch();

  const forexCurrencyTicker = useSelector(
    (state) => state.quote.forexCurrencyTicker
  );

  // const forexCurrencyRate = useSelector(
  //   (state) => state.quote.forexCurrencyRate,
  // )

  //console.log(forexCurrencyTicker + ' ' + forexCurrencyRate)

  const forexRates = useSelector((state) => state.quote.rates);

  useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const fetchURL = `https://v6.exchangerate-api.com/v6/${apiCurrnecyKey}/latest/THB`;

        console.log(fetchURL);
        const response = await fetch(fetchURL);
        const data = await response.json();

        dispatch(
          quoteActions.setRates({
            rates: data.conversion_rates,
          })
        );
      } catch (error) {
        console.log(error);
        // ...
      }
    };
    fetchExchangeRate();
  }, [dispatch]);

  const currencyDropDownChangeHandler = (event) => {
    dispatch(
      quoteActions.setForexTicker({
        forexCurrencyTicker: event.target.value,
        forexCurrencyRate: forexRates[event.target.value],
      })
    );
  };

  // const forexDropDown = (
  //   <select
  //     className={classes.currencyDropDown}
  //     onChange={currencyDropDownChangeHandler}
  //     value={forexCurrencyTicker}
  //   >
  //     <option value="THB">THB - Thai Baht</option>
  //     <option value="AUD">AUD - Australian Dollar</option>
  //     <option value="GBP">GBP - British Pound</option>
  //     <option value="USD">USD - US Dollar</option>
  //     <option value="EUR">EUR - Euro</option>
  //     <option value="AED">AED - UAE Dirham</option>
  //     <option value="CAD">CAD - Canadian Dollar</option>
  //   </select>
  // )

  return (
<div className={classes.forexContainer}>
  <button
    value="AED"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencyAED} ${classes.currencyButton} ${
      forexCurrencyTicker === "AED" ? classes.currencySelected : ""
    }`}
  >
    د.إ - AED
  </button>

  <button
    value="AUD"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencyAUD} ${classes.currencyButton} ${
      forexCurrencyTicker === "AUD" ? classes.currencySelected : ""
    }`}
  >
    $ - AUD
  </button>

  <button
    value="CAD"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencyCAD} ${classes.currencyButton} ${
      forexCurrencyTicker === "CAD" ? classes.currencySelected : ""
    }`}
  >
    $ - CAD
  </button>

  <button
    value="CNY"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencyCNY} ${classes.currencyButton} ${
      forexCurrencyTicker === "CNY" ? classes.currencySelected : ""
    }`}
  >
    ¥ - CNY
  </button>  

  <button
    value="EUR"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencyEUR} ${classes.currencyButton} ${
      forexCurrencyTicker === "EUR" ? classes.currencySelected : ""
    } `}
  >
    € - EUR
  </button>

  <button
    value="GBP"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencyGBP} ${classes.currencyButton} ${
      forexCurrencyTicker === "GBP" ? classes.currencySelected : ""
    }`}
  >
    £ - GBP
  </button>

  <button
    value="HKD"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencyHKD} ${classes.currencyButton} ${
      forexCurrencyTicker === "HKD" ? classes.currencySelected : ""
    }`}
  >
    $ - HKD
  </button>

  <button
    value="SAR"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencySAR} ${classes.currencyButton} ${
      forexCurrencyTicker === "SAR" ? classes.currencySelected : ""
    }`}
  >
    ﷼ - SAR
  </button>      

  <button
    value="SGD"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencySGD} ${classes.currencyButton} ${
      forexCurrencyTicker === "SGD" ? classes.currencySelected : ""
    }`}
  >
    S$- SGD
  </button>  

  <button
    value="USD"
    onClick={currencyDropDownChangeHandler}
    className={`${classes.currencyUSD} ${classes.currencyButton} ${
      forexCurrencyTicker === "USD" ? classes.currencySelected : ""
    }`}
  >
    $ - USD
  </button>
</div>

  );
};

export default BookingCurrencyConverter;

// {forexRates && (
//   <div className={classes.dropDownContainer}>{forexDropDown}</div>
// )}
